import { render } from "./ViewTeacher.vue?vue&type=template&id=f6000106&scoped=true"
import script from "./ViewTeacher.vue?vue&type=script&lang=js"
export * from "./ViewTeacher.vue?vue&type=script&lang=js"

import "./ViewTeacher.vue?vue&type=style&index=0&id=f6000106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6000106"]])

export default __exports__